import * as types from './mutation-types'
import Vue  from 'vue'
import { IUserState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbUser, IAloDbUserConstParam } from '@/models/alodb/AloDbUser';
import { AloDbRoleMapping } from '@/models/alodb/AloDbRoleMapping';
import { WobAdminChanged } from '@/models/wob/WobAdminChanged';
import deepEqual from 'deep-equal';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IUserState> = {
     
    //Gestion des recherches de missions
    [types.USER_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.User.Title').toString()}).toString()
        state.userLoading = true
    },
    [types.USER_SUCCESS]: (state, users:Array<AloDbUser>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.User.Title').toString()}).toString()
        state.users = users   
        state.userLoading = false             
    },
    [types.USER_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.User.Title').toString()}).toString()
        state.users = []
        state.userLoading = false
    },
    [types.USER_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.User.Title').toString()} ${itemId}`}).toString()
        state.userLoading = true
    },
    [types.USER_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.User.Title').toString()}).toString()
        state.userLoading = false
    },
    [types.USER_SELECT_DETAIL_SUCCESS]: (state,user:AloDbUser) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.User.Title').toString()} ${user.USR_ID}`}).toString()        
        //1, on met à jour de m'user dans la liste des users
        const index = state.users.findIndex(m => m.USR_ID == user.USR_ID)
        state.users.splice(index == -1 ? state.users.length : index, index == -1 ? 0 : 1, user)
        state.userLoading = false
    },
    [types.USER_SELECT_DETAIL]: (state,user:AloDbUser) => {                
        state.originalAdmUser = user
        state.modifiedAdmUser = new AloDbUser(user)
    },
    [types.USER_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.User.Title').toString()} ${libelle}`}).toString()
        state.userLoading = true
    },
    [types.USER_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.User.Title').toString()}).toString()
        state.userLoading = false
    },
    [types.USER_DELETE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.DeleteItem',{item:`${i18n.t('Admin.User.Title').toString()} ${libelle}`}).toString()
        state.userLoading = true
    },
    [types.USER_DELETE_SUCCESS]: (state,usrId:number) => {
        state.status = i18n.t('Admin.DeleteItemOk',{item:`${i18n.t('Admin.User.Title').toString()} ${usrId}`}).toString()        
        const index = state.users.findIndex(u => u.USR_ID == usrId)
        state.users.splice(index == -1 ? state.users.length : index, index == -1 ? 0 : 1)
        state.userLoading = false
    },
    [types.USER_DELETE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorDelete',{item:i18n.t('Admin.User.Title').toString()}).toString()
        state.userLoading = false
    },
    [types.USER_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmUser = {...state.modifiedAdmUser,...newProperties}
    },
    [types.USER_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    },
    [types.USER_ROLEMAPPING_REQUEST]: (state, itemId:number) => {
        state.status = `loading role mapping for user ${itemId}`
        state.roleMappingLoading = true
    },
    [types.USER_ROLEMAPPING_SUCCESS]: (state, rolesMapping:Array<AloDbRoleMapping>) => {
        state.status = 'success loading role mapping for user '
        state.modifiedAdmUserRolesMapping = rolesMapping   
        state.roleMappingLoading = false             
    },
    [types.USER_ROLEMAPPING_ERROR]: state => {
        state.status = 'error loading role mapping for user'
        state.modifiedAdmUserRolesMapping = []
        state.roleMappingLoading = false
    },
    [types.USER_ADD_ROLEMAPPING_REQUEST]: (state, {usrId,mapObject,mapId,rolKey}:{usrId:number,mapObject:string,mapId:number,rolKey:string}) => {
        Vue.set(state.roleMappingLoadingByType, mapObject, true) 
        //state.status = `loading role mapping for user ${itemId}`        
    },
    [types.USER_ADD_ROLEMAPPING_SUCCESS]: (state, roleMapping:AloDbRoleMapping) => {
        //on s'assure que l'utilisateur en cours est toujours le bon
        if(state.originalAdmUser.USR_ID == roleMapping.USR_ID) {
            const index = state.modifiedAdmUserRolesMapping.findIndex(m => m.USR_ID == roleMapping.USR_ID && m.MAP_OBJECT == roleMapping.MAP_OBJECT && m.MAP_ID == roleMapping.MAP_ID  && m.ROL_KEY == roleMapping.ROL_KEY)
            //on s'assure que le mapping n'est pas deja présent
            if(index == -1) state.modifiedAdmUserRolesMapping.push(roleMapping)
        }
        state.roleMappingLoadingByType[roleMapping.MAP_OBJECT!] = false        
    },
    [types.USER_ADD_ROLEMAPPING_ERROR]: (state,mapObject:string) => {
        //state.status = 'error adding mapping role'        
        state.roleMappingLoadingByType[mapObject] = false
    },
    [types.USER_REMOVE_ROLEMAPPING_REQUEST]: (state, {usrId,mapObject,mapId,rolKey}:{usrId:number,mapObject:string,mapId:number,rolKey:string}) => {
        Vue.set(state.roleMappingLoadingByType, mapObject, true) 
        //state.status = `loading role mapping for user ${itemId}`        
    },
    [types.USER_REMOVE_ROLEMAPPING_SUCCESS]: (state, roleMapping:AloDbRoleMapping) => {
        //on s'assure que l'utilisateur en cours est toujours le bon
        if(state.originalAdmUser.USR_ID == roleMapping.USR_ID) {
            const index = state.modifiedAdmUserRolesMapping.findIndex(m => m.USR_ID == roleMapping.USR_ID && m.MAP_OBJECT == roleMapping.MAP_OBJECT && m.MAP_ID == roleMapping.MAP_ID  && m.ROL_KEY == roleMapping.ROL_KEY)            
            state.modifiedAdmUserRolesMapping.splice(index == -1 ? state.modifiedAdmUserRolesMapping.length : index, index == -1 ? 0 : 1)            
        }
        state.roleMappingLoadingByType[roleMapping.MAP_OBJECT!] = false
    },
    [types.USER_REMOVE_ROLEMAPPING_ERROR]: (state,mapObject:string) => {
        //state.status = 'error adding mapping role'        
        state.roleMappingLoadingByType[mapObject] = false
    },
    [types.USER_CHANGE_PASSWORD_REQUEST]: (state, usrId:number) => {        
        state.status = `changing password for user ${usrId}`        
        state.userLoading = true
    },
    [types.USER_CHANGE_PASSWORD_SUCCESS]: (state, usrId:number) => {
        //on s'assure que l'utilisateur en cours est toujours le bon
        state.status = `password for user ${usrId} changed succefully`   
        state.userLoading = false        
    },
    [types.USER_CHANGE_PASSWORD_ERROR]: (state,usrId:number) => {
        state.status = `error in changing password for user ${usrId}`   
        state.userLoading = false
    },
    [types.USER_EXTERNAL_UPDATE]: (state, wob: WobAdminChanged<AloDbUser>) => {        
        //on met à jour ou ajoute l'objet dans la liste
        if(wob.actionType == "Added" || wob.actionType == "Modified") {
            //1, on met à jour de m'mission dans la liste des missions
            const index = state.users.findIndex(u => u.USR_ID == wob.newAloDbItem.USR_ID)
            state.users.splice(index == -1 ? state.users.length : index, index == -1 ? 0 : 1, wob.newAloDbItem)        
            if(state.originalAdmUser.USR_ID == wob.newAloDbItem.USR_ID) {            
                if(deepEqual(state.originalAdmUser,state.modifiedAdmUser)){
                    state.modifiedAdmUser = new AloDbUser(wob.newAloDbItem as IAloDbUserConstParam)
                }                        
                state.originalAdmUser = wob.newAloDbItem                        
            }
        }
        //on supprime l'objet de la liste si existant
        else if(wob.actionType == "Deleted") {
            const index = state.users.findIndex(u => u.USR_ID == wob.oldAloDbItem.USR_ID)
            state.users.splice(index == -1 ? state.users.length : index, index == -1 ? 0 : 1)        
        }
    }
}


export default mutations
